export const HEADERS_ARRAY = [
	[<th colSpan={2}>Claims 'To correct'</th>],
	[<th>Product</th>, <th>Email</th>],
];
